
import SplitWall from '../component/2D/SplitWall';
; (function () {
    'use strict';

    var directive = function () {
        return {
            restrict: 'E',
            template: [
               '<img data-toggle="tooltip" data-placement="top" title="Split wall" alt="Split wall"',
                    ' ng-click="buttonClick()" src="assets/images/tools/scissors.png" />'
            ].join(''),
            replace: true,
            scope : {},
            controller: controller
        }
    };

    var dependencies = ['$scope', 'engine2DSrvc','Scene2d'];

    var controller = function ($scope, engine2DSrvc, Scene2d) {

        $scope.buttonClick = function () { 
            engine2DSrvc.get().findComponentByType(SplitWall).enable();
        };

    };

    controller.$inject = dependencies;

    angular.module('valleyCraftApp').directive('splitWallButton', directive);

})();
